<template>
    <div class="hbp-container hbp-container-above">
        <div class="announcement router-view">
            <!-- 公告图标 -->
            <div class="announcement-breadcrumb">
                <div aria-label="Breadcrumb"
                    role="navigation"
                    class="xui-breadcrumb">
                    <span class="xui-breadcrumb__item"
                        aria-current="page">
                        <span role="link"
                            class="xui-breadcrumb__inner is-link">
                            <img src="../../../images/ancmt-icon.png">
                            <router-link to="/announcement"><span> 公告新闻</span></router-link>
                        </span>
                        <i class="xui-breadcrumb__separator xui-icon-arrow-right"></i>
                    </span>
                    <span class="xui-breadcrumb__item">
                        <span role="link"
                            class="xui-breadcrumb__inner">公告详情</span>
                        <i class="xui-breadcrumb__separator xui-icon-arrow-right"></i>
                    </span>
                </div>
            </div>

            <div class="announcement-panel">
                <div class="announcement-detail">
                    <h3 class="announcement-detail-title">{{title}}</h3>
                    <p class="announcement-detail-info">
                        <span>发布日期：{{time}}</span>
                    </p>
                    <div class="detail-html"
                        v-html="content"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'announcementDetail',
  data() {
    return {
      detailData: {},
      title: 'wait.',
      time: '',
      content: ``,
    };
  },
  created() {
    console.log(this.$route.query.code, 'this.$route.query.code');
    // this.axios.get("api/getDetail", this.$route.query.code).then(result => {
    //     this.detailData = result.data.detailData
    // })
  },
  mounted() {
    document.getElementsByClassName('xui-scrollbar__wrap')[0].scrollTo(0,0);
    let s = new Promise((resolve, reject) => {
      this.$http
        .get('vul/hsrc/vul/report/services/announcement/queryById?announcementId=' + this.$route.query.code, {})
        .then((res) => {
          console.log(res);
          if (res.status === 200 && res.data.data) {
            this.time = res.data.data.creationDateStr;
            this.title = res.data.data.title;
            // XSS
            this.content = this.xssDefend(res.data.data.content);
            // this.content = res.data.data.content;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    });
  },
  methods: {
    xssDefend(str) {
      if (typeof str !== 'string') {
        return '';
      }
      let html = window.filterXSS(str, {
        whiteList: {
          table: ['width', 'border', 'align', 'valign'],
          tbody: ['align', 'valign', 'text-align'],
          td: ['width', 'rowspan', 'colspan', 'align', 'valign'],
          tfoot: ['align', 'valign'],
          th: ['width', 'rowspan', 'colspan', 'align', 'valign'],
          thead: ['align', 'valign', 'text-align'],
          tr: ['rowspan', 'align', 'valign', 'text-align'],
          tt: [],
          a: ['target', 'href', 'title'],
          abbr: ['title'],
          address: [],
          area: ['shape', 'coords', 'href', 'alt'],
          article: [],
          aside: [],
          b: [],
          bdi: ['dir'],
          bdo: ['dir'],
          big: [],
          blockquote: ['cite'],
          br: [],
          caption: [],
          center: [],
          cite: [],
          code: [],
          col: ['align', 'valign', 'span', 'width'],
          colgroup: ['align', 'valign', 'span', 'width'],
          dd: [],
          del: ['datetime'],
          details: ['open'],
          div: [],
          dl: [],
          dt: [],
          em: [],
          font: ['color', 'size', 'face'],
          footer: [],
          h1: [],
          h2: [],
          h3: [],
          h4: [],
          h5: [],
          h6: [],
          header: [],
          hr: [],
          i: [],
          img: ['src', 'alt', 'title', 'width', 'height'],
          ins: ['datetime'],
          li: [],
          mark: [],
          nav: [],
          ol: [],
          p: [],
          pre: [],
          s: [],
          section: [],
          small: [],
          span: [],
          sub: [],
          sup: [],
          strong: [],
          u: [],
          ul: [],
          p: ['style'],
          strong: ['style'],
          span: ['style'],
          br: [],
          img: ['style', 'src', 'border', 'width', 'height'],
        },
        stripIgnoreTag: true, // 过滤所有非白名单标签的HTML
        stripIgnoreTagBody: ['script', 'iframe'], // script标签较特殊，需要过滤标签中间的内容
      });
      return html;
    },
  },
};
</script>
<style lang="less" scoped>
@import '../../../global/variable';
.announcement-panel {
  .announcement-detail {
    width: 100%;
    padding: 0.5rem;
    font-size: 0.8rem;
    color: #666;
    .announcement-detail-title {
      padding: 0.5rem;
      font-size: 1.2rem;
      font-weight: 500;
      word-break: break-word;
    }
    .announcement-detail-info {
      padding: 0.5rem 0.5rem 1rem 0.5rem;
      font-size: 0.8rem;
      line-height: 0.8rem;
      color: #666;
    }
    .detail-html {
      padding: 10px 0.5rem;
      text-align: justify;
      word-break: break-all;
      max-width: 100%;
      .pageAnnouncementDetailMinHeight();
      /deep/ p {
        margin: 1rem 0;
        font-size: 0.8rem;
        line-height: 2;
        text-align: justify;
      }
      /deep/img {
        width: auto;
        max-width: 100%;
      }
      /deep/td,
      th {
        padding: 5px 10px;
        border: 1px solid #666;
        line-height: initial;
        text-align: left;
      }
      /deep/table {
        margin: 1rem 0;
        border-collapse: collapse;
        display: table;
        width: 100%;
      }
    }
  }
}
.hbp-container {
  width: 100%;
  position: relative;
  overflow-y: scroll;
  .announcement {
    max-width: 63rem;
    margin: 0 auto;
    .announcement-breadcrumb {
      padding: 1rem 0.25rem;
      .xui-breadcrumb {
        font-size: 14px;
        line-height: 1;
        .xui-breadcrumb__item {
          height: 2rem;
          line-height: 2rem;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          .xui-breadcrumb__inner {
            display: inline-flex;
            align-items: center;
            cursor: pointer;
            font-size: 0.8rem !important;
            span {
              padding: 0 0.25rem;
              font-size: 0.8rem !important;
            }
          }
          .is-link {
            font-weight: normal !important;
          }
        }
      }
    }
  }
}
.hbp-container .announcement .announcement-breadcrumb .xui-breadcrumb .xui-breadcrumb__item .xui-breadcrumb__inner span {
  color: #666;
  &:hover {
    color: #409eff;
    text-decoration: none;
  }
}
.xui-breadcrumb__separator,
.xui-icon-arrow-right {
  margin: 0 6px !important;
  font-weight: 400 !important;
  color: #c0c4cc !important;
}
a {
  text-decoration: none;
  &:hover {
    text-decoration: none !important;
  }
  span &:hover {
    text-decoration: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/announcement/detail/AnnouncementDetail.vue